export type Awaitable<T> = T | Promise<T>;

const inBrowser =
	typeof window !== "undefined" &&
	typeof window.requestIdleCallback === "function";

const schedule = inBrowser
	? (cb: () => void) => window.requestIdleCallback(cb)
	: typeof setImmediate === "function"
		? setImmediate
		: (cb: () => void, delay?: number) => setTimeout(cb, delay);

export function runInBackground<T>(
	fn: () => Awaitable<T>,
	delay?: number,
): void {
	schedule(() => fn(), delay);
}

export function runInBackgroundAsync<T>(
	fn: () => Awaitable<T>,
	delay?: number,
): Promise<T> {
	return new Promise<T>((resolve, reject) => {
		schedule(async () => {
			try {
				const value = await fn(); // resolves nested async work
				resolve(value);
			} catch (e) {
				reject(e);
			}
		}, delay);
	});
}
